export const CONCEPTS_ANIMATIONS = {
  blackboard: 'blackboard',
  machine: 'machine',
  markets: 'markets'
}
